import { ConfirmModalService } from './../shared/confirm-modal/confirm-modal.service';
import { Subscription } from 'rxjs';
import { MenuService } from './../../services/menu.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { RouteDataService } from './../../services/route-data.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, Renderer2, HostBinding, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import { APP_CONFIG } from '../../app.config';
import { IAppConfig } from '../../app.config.shared';
import { LoginInfo } from '../../models';
import { LoginService } from '../../services/login.service';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';

declare var SnapEngage;
declare var $;

@Component({
  selector: 'app-student-student-menu',
  templateUrl: './student-menu.component.html',
  styleUrls: ['./student-menu.component.scss']
})
export class StudentMenuComponent implements OnInit, OnDestroy {
  routerList: Array<any>;
  @ViewChild('sidemenu') sideMenu;
  @HostBinding('class.ns-navigation-collapsed') navigationCollapsed = true;
  studentUserId;
  isLogout = false;
  loginDetail: Partial<LoginInfo>;
  menuMessageCount = 0;
  menuCoachingHubCount = 0;
  coachingHours;
  currentUrl;
  menuScroll = true;
  temp = 'home';
  isFirstLogin: boolean;
  saveModal = false;
  pinMenuBar: boolean;
  currentRoute;
  refreshInterval: any;
  subscription: Subscription[] = [];
  localData: any;
  duplicateContact: any = false;
  partnerDetail: any;

  constructor(
    private notificationService: NotificationService,
    @Inject(APP_CONFIG) private config: IAppConfig,
    private _commonAuthService: CommonAuthenticationService,
    private _routeDataService: RouteDataService,
    private _commonService: CommonService,
    private _commonDataSharedService: CommonDataSharedService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _router: Router,
    private _loginService: LoginService,
    private _menuService: MenuService,
    private renderer: Renderer2,
    private confirmModalService: ConfirmModalService,
    private routes: ActivatedRoute,
    private draggableModalService: DraggableModalService
  ) {
    _router.events.subscribe(event => {

      if (event instanceof NavigationStart) {
        this.currentUrl = event.url;
        if (event.url !== '/student/studentProfileHome') {
          this._commonDataSharedService.studentProfileNavigation.next(true);
        }
      }
    });
  }

  ngOnInit() {
    this.navigationCollapsed = true;
    if (JSON.parse(localStorage.getItem('toggleMenu'))) {
      this.pinMenuBar = JSON.parse(localStorage.getItem('toggleMenu'));
    }
    const partnerDetail = localStorage.getItem('partnerDetail');
    if (partnerDetail) {
      this.partnerDetail = JSON.parse(partnerDetail);
    }
    const routeParam = this._router.url.split('/').pop();
    let selectMenu;
    this.getLoginDetail();
    this._commonDataSharedService.collapseMenu.subscribe((data: any) => {
      this.navigationCollapsed = this.pinMenuBar ? false : true;
      this.menuScroll = false;
    });
    this._commonDataSharedService.sidemenu.next(this.sideMenu);
    this.subscription.push(
      this._commonDataSharedService.duplicateContact.subscribe(data => {
        this.duplicateContact = data;
      }),
      this._commonDataSharedService.isFirstLogOn.subscribe(data => {
        this.isFirstLogin = false;
      }),
      this._routeDataService.studentRouteData.subscribe((data: Array<any>) => {
        this.localData = JSON.parse(localStorage.getItem('loginUserData'));
        this.routerList = this.localData.myCapAccess ? data : data.filter(routeItem => routeItem.path !== 'MyCap');
        this.isFirstLogin = this.localData.isFirstLogOn;
        this._commonService.setDataWithoutObservable(this.routerList, 'routerList');
        selectMenu = this._commonService.checkParentExist(this.routerList, { path: routeParam });
        if (selectMenu.mainIndex > -1) {
          this._commonService.toggleSideMenu(this.routerList, this.routerList[selectMenu.mainIndex]);
        }
        this._menuService.selectMenu(this.routerList, { path: routeParam });
      }),
      this._routeDataService.logout.subscribe((data: any) => {
        this.isLogout = true;
        this._commonService.hideHelpMenuAndPopup();
      }),
      this._commonDataSharedService.updateMessageCount.subscribe((data: any) => {
        this.getCountValue();
      }),
    )


    if (!this.isLogout) {
      this.onLiveChat();
      this._commonService.showHelpMenuAndPopup();
    }
    this.refreshInterval = setInterval(() => {
      this.getCountValue();
    }, 60 * 1000);

    this.getCountValue();

    this._commonRequestResponseService.post('admin/getoperatingHours', {})
      .subscribe(
        (data: any) => {
          this.coachingHours = data.message;
        },
        error => {
          console.error('error', error)
        })

    this._commonDataSharedService.saveModal.subscribe((data) => {
      this.currentRoute = data;
      this.saveModal = true;
    });
    this._commonDataSharedService.questionModal.subscribe((data: any) => {
      this.currentRoute = data.currentRoute;
      this.saveModal = data.value;
    });
  }

  pinMenu(event) {
    event.stopPropagation()
    this.pinMenuBar = !this.pinMenuBar;
    localStorage.setItem('toggleMenu', this.pinMenuBar.toString())
    if (this.pinMenuBar) {
      this.navigationCollapsed = false;
      this.renderer.addClass(document.body, 'menu-open');
    } else {
      this.navigationCollapsed = true;
      this.menuScroll = false;
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  getCountValue() {
    this._commonRequestResponseService.post('shared/get/counts', { userRoleData: this._commonAuthService.getRoleName() })
      .subscribe(
        (countData: any) => {
          this.menuMessageCount = countData.messagesCount;
          this.menuCoachingHubCount = countData.coachingHubCount;
          this._commonDataSharedService.countUpdate.next(countData);
        },
        () => {
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  onStudentMenuRouteClick(route, toggleFlag) {
    localStorage.removeItem('careerCode');
    localStorage.removeItem('searchResult');
    localStorage.removeItem('navigateCareer');
    localStorage.removeItem('careerActiveRoute');

    if (this._router.url.split('/').pop() === 'studentProfile') {
      if (this._router.url.split('/').pop() !== route.path) {
        this._commonDataSharedService.saveProfile.next();
      }
    }
    if (toggleFlag) {
      this._commonService.toggleSideMenu(this.routerList, route);
    }
    if (!this.pinMenuBar) {
      this.renderer.removeClass(document.body, 'menu-open');
      this.navigationCollapsed = true;
      this.menuScroll = false;
    }
    this._menuService.selectMenu(this.routerList, route);
    this._menuService.setCurrentRouteData(route);



    if (this.saveModal && this.currentRoute === 'studentProfile' && !['colleges', 'studentProfileHome'].includes(route.path)) {
      this.confirmModalService.open({
        ok: () => {
          if (this.duplicateContact === true) {
            this._routeDataService.setStudentMenuRoute.next('./../' + route.moduleName.toLowerCase().trim() + '/' + route.path);
            this._commonDataSharedService.studentProfileSave.next();
            this.saveModal = false;
          }
        },
        cancel: () => {
          this._routeDataService.setStudentMenuRoute.next('./../' + route.moduleName.toLowerCase().trim() + '/' + route.path);
          this.saveModal = false;
        },

        text: 'Would you like to save the changes you’ve made?',
        labels: ['Yes', 'No']
      });
    } else if (this.saveModal && this.currentRoute === 'myCoachingHub') {
      const content = `
      <p>Your progress on this page will be lost</p>
    `;
      const modal = this.draggableModalService.show({
        id: 'alert-modal',
        trayTitle: 'Career Assessment',
        initialState: {
          content,
          footer: true
        }
      });
      modal.content.onSubmit.subscribe(() => {
        this._routeDataService.setStudentMenuRoute.next('./../' + route.moduleName.toLowerCase().trim() + '/' + route.path);
        this.saveModal = false;
        modal.content.hide();
      })
    } else {
      this.saveModal = false;
      if (route && route.path && !['colleges', 'studentProfileHome'].includes(route.path)) {
        this.temp = route.path;
        this._commonService.setBreadCrumb(route, this.routerList, 'student');
        if (route.name.replace(/ /g, '').toLowerCase() === 'manageyoursubscription') {
          window.open(route.path, '_blank');
        } else {
          this._routeDataService.setStudentMenuRoute.next('./../' + route.moduleName.toLowerCase().trim() + '/' + route.path);
        }
      }
    }

  }

  onLiveChat() {
    const snapEngage = this.partnerDetail ? this.partnerDetail.snapEngage : '';
    const __this = this;
    (function () {
      const se = document.createElement('script');
      se.type = 'text/javascript';
      se.async = true;
      se.src = snapEngage;
      let done = false;
      se.onload = function () {
        if (!done && __this.loginDetail) {
          done = true;
          SnapEngage.setUserEmail(__this.loginDetail.email);
          SnapEngage.setUserName(__this.studentUserId);
        }
      };

      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(se, s);
    })();

    if ($('#snapengage-mobile')) {
      setTimeout(function () {
        $('#snapengage-mobile').css({
          'z-index': '99999999',
          'top': '31px',
          'bottom': '31px',
          'right': '31px',
          'left': '31px'
        });

        const iframe: any = document.getElementById('snapengage-mobile-iframe');

        if (iframe) {
          const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
          innerDoc.getElementById('SnapABug_email').value = __this.loginDetail.email;
        }
      }, 1000);
    }
  }

  logout() {
    localStorage.removeItem('toggleMenu');
    this.renderer.removeClass(document.body, 'menu-open');
    this._loginService.logout().subscribe(() => {
      this.isLogout = true;
    });
  }

  getLoginDetail() {
    this.loginDetail = this._commonAuthService.getLoginData();
    this.studentUserId = this._commonAuthService.getUserId();
    if (this.loginDetail && this.loginDetail.isLogin === 'true') {
      this.isLogout = false;
    }
  }

  toggleNavigationCollapse() {

    if (this.pinMenuBar && this.navigationCollapsed) {
      this.renderer.addClass(document.body, 'menu-open');
    }
    else if (!this.pinMenuBar && this.navigationCollapsed) {
      this.renderer.addClass(document.body, 'menu-open');
    }
    else {
      this.renderer.removeClass(document.body, 'menu-open');
    }

    this.navigationCollapsed = !this.navigationCollapsed;
    localStorage.setItem('toggleMenu', this.navigationCollapsed.toString())
  }

  toggleNavigationCollapseMobile(shouldCollapseMenu: boolean) {
    if (typeof shouldCollapseMenu === 'undefined') {
      shouldCollapseMenu = true;
    }
  }

  routeHasChildren(route) {
    return route.innerItems.filter((item) => item.access === 'true').length > 0;
  }

  ngOnDestroy() {

    this.subscription.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
    clearInterval(this.refreshInterval);
  }
}
